import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider, Empty } from 'antd';
import { ExcelIcon } from 'icons';
import { Link, Route, Routes, useLocation } from 'react-router-dom';
import DeleteModal from 'components/deleteModalView';
// import Filters from './filters';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useVacancies from '../useVacancies';
import UIHelper from '../../../../../helpers/UIHelper';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../hooks/useUser';

const MainPage = () => {
  const {
    data,
    columns,
    filters,
    loading,
    handleDownloadExcel,
    onDelete,
    updateInProcess,
    onChangeTableFilter,
  } = useVacancies();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const pages = useRecoilValue(getPage);

  return (
    <>
      <PageHeader title={t('Annunci online').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              loading={updateInProcess}
              onClick={handleDownloadExcel}
              icon={<ExcelIcon fill={'#fff'} />}
            >
              {t('Export')}
            </Button>
          </Col>
          {pages?.ability?.can_create && (
            <Col>
              <Link to={`${pathname}/new`}>
                <Button big icon={<PlusOutlined />}>
                  {t('Pubblica Annuncio')}
                </Button>
              </Link>
            </Col>
          )}
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <Divider />
        <Table
          locale={{
            emptyText: <Empty />,
          }}
          columns={UIHelper.assignTire(columns)}
          dataSource={data.vacancies}
          pagination={data.pagination}
          loading={loading}
          onChange={onChangeTableFilter}
          scroll={{ x: 2000 }}
          // bordered
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal loading={updateInProcess} onClickDelete={onDelete} />
          }
        />
      </Routes>
    </>
  );
};

export default MainPage;
